var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-setting-room-status-add'},"title":_vm.$t('manage.room-status.text')}}),_c('List',{attrs:{"dataList":_vm.data,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"fields":[ 
          ("name: " + (_vm.$t('manage.service.name'))),
          ("name_en: " + (_vm.$t('manage.name_en'))),
          ("color_code: " + (_vm.$t('manage.room-status.color'))) ],"formats":[],"edit":{link: 'manage-setting-room-status-edit'},"filter":{
          search: ['mg_room_statuses.name','mg_room_statuses.name_en']
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }